import { render } from "./UserSummary.vue?vue&type=template&id=2acb83f4&scoped=true&ts=true"
import script from "./UserSummary.vue?vue&type=script&lang=ts"
export * from "./UserSummary.vue?vue&type=script&lang=ts"

import "./UserSummary.vue?vue&type=style&index=0&id=2acb83f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acb83f4"]])

export default __exports__